/**
 * Created by lari on 03/05/2017.
 */
/* either pass list of clients (patients) to dispay or load clients/patients depending on mode */


(function () {
  'use strict';
  angular.module('vcdrug')
    .component('drugconfig', {
      restrict: 'E',
      bindings: {},
      template: `
      <div class="panel panel-info">
        <div class="panel-heading">
          <h3>Medikamenten-Signaturen</h3>
        </div>
        <div class="panel-body"></div>
          <div class="modalspacer">
            <label>Häufig gebrauchte Medikamentensignaturen</label>
            <listeditor list="vm.drugsignature.drugsignature" parentsave="vm.childsave(list)"></listeditor>
          </div>
        </div>
  `,
      controllerAs: 'vm',
      controller: ['$log', 'Rlog', 'Config', 'vertxEventBusService',
        function ($log, Rlog, Config, vertxEventBusService) {
          let vm = this;
          vm.childsave = childsave;

          vm.$onInit = function () {
            // vm.drugsignature = Config.$find('drugconfig');

            Config.$find('drugconfig').$then(function (sigs) {
              vm.drugsignature = sigs;
              // intialize if still empty
              if (!angular.isArray(vm.drugsignature.drugsignature)) {
                vm.drugsignature.drugsignature = [];
              }
              if (!angular.isString(vm.drugsignature._id)) {
                vm.drugsignature._id = 'drugconfig';
              }
            });
          };

          function childsave(list) {
            vm.drugsignature.drugsignature = list;
            save();
          }


          function save() {
            if (vm.drugsignature.$hasPendingActions()) {
              vm.drugsignature.$cancel();
            }
            vm.drugsignature.$save();
          }

          const consfigUpdateHandler = function (message) {
            // $log.debug('debug: config update received: ', message);
            let messages = message.split(':');
            if (messages[0] === 'drugsignature') {
              vm.drugsignature.$refresh().$then(function () {
                $log.debug('debug: config refresh drugsignatures');
              }, function (error) {
                $log.debug('debug: config refresh drugsignatures failed: ', error);
              });
            }
          };

          vertxEventBusService.on('config.update', {}, consfigUpdateHandler);

          vm.$onDestroy = function () {
            vertxEventBusService.unregisterHandler('config.update', {}, consfigUpdateHandler);
          };


        }] // controller
    }); // component

  // klammerfriedhof
}());
